import { Box } from '@pets-ui/Box/Box'
import { ErrorFilled } from '@pets-ui/icons'
import { Slide } from '@pets-ui/Slide/Slide'
import { useSnackbar } from '@pets-ui/Snackbar/useSnackbar'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, Redirect } from 'react-router-dom-v5'
import { getClient } from '../../clients'
import { useApiAdminLogin } from '../../hooks/apis/useApiAdminLogin'
import { useCampaign } from '../../hooks/use-campaign'
import style from '../../style/pages/admin-login.module.scss'

const styles = stylex.create({
  slide: {
    width: '100%',
  },
})

export const AdminLogin = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const history = useHistory()
  const [password, setPassword] = useState<string>('')
  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')
  const { t } = useTranslation()
  const { trigger: adminLogin } = useApiAdminLogin()
  const { openSnackbar } = useSnackbar()

  const loginAdmin = useCallback(async () => {
    try {
      const { data } = await adminLogin({ code: campaignCodeFromUrl, password })
      if (data.data.token) {
        sessionStorage.setItem('admin', JSON.stringify(data.data))
        getClient('fastpassAdmin').defaults.headers['admin-access-token'] = data.data.token
        history.push(`/admin/${campaignCodeFromUrl}/admin-scan`)
      }
    }
    catch (error) {
      console.error(error)
      openSnackbar({
        message: '登入失敗',
        anchorOrigin: { horizontal: 'center', vertical: 'top' },
        icon: <ErrorFilled color={colors.red600} />,
      })
    }
  }, [adminLogin, campaignCodeFromUrl, history, openSnackbar, password])

  if (adminToken?.token) {
    return <Redirect to={`/admin/${campaignCodeFromUrl}/admin-scan`} />
  }

  return (
    <VStack height="100vh" justifyContent="center" alignItems="center" backgroundColor="#009ccc">
      <VStack flex={1} justifyContent="center">
        <img
          src="https://cdn.moneynet.tw/common/images/logo_buygather_login.png"
          alt="fastpass"
        />
      </VStack>
      <Slide direction="up" in={true} rootStyle={styles.slide}>
        <Box className={style['login-from']}>
          <label htmlFor="staff" className={style['id-label']}>
            ID
          </label>
          <input
            type="text"
            inputMode="numeric"
            placeholder={t('login.placeholder') || ''}
            id="staff"
            className={style['login-input']}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
            }}
          />
          <button className={style['login-button']} onClick={loginAdmin}>
            {t('login.button')}
          </button>
        </Box>
      </Slide>
    </VStack>
  )
}
